const HistoryModel = {
    productName: '',
    invoice: '',
    amount: 0,
    currentAmount: 0,
    username: '',
    action: '',
    timestamp: '',
    date: '',
};

export default HistoryModel;
